import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // return next(req);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (!router.url.includes('/login')) {
          // console.log('Sesión expirada, redirigiendo al login...');
          router.navigate(['/login']);
        }
      }
      
      return throwError(() => error);
    })
  );
};
